import React, { FC } from 'react';
import { Dayjs } from 'dayjs';
import { StyledDate } from '../styles';

interface MultiDatePickerDateRenderProps {
  currentDate: Dayjs;
  isSelected: boolean;
}

const MultiDatePickerDateRender: FC<MultiDatePickerDateRenderProps> = ({ currentDate, isSelected }) => {
  return (
    <StyledDate selected={isSelected} role="button">
      {currentDate.date()}
    </StyledDate>
  );
};

export default MultiDatePickerDateRender;
